// extracted by mini-css-extract-plugin
export var partner = "newsletter-partner-module--partner--add9b";
export var partnerImage = "newsletter-partner-module--partnerImage--b708c";
export var partnerPrefix = "newsletter-partner-module--partnerPrefix--b7856";
export var partner__feature = "newsletter-partner-module--partner__feature--09317";
export var spin = "newsletter-partner-module--spin--abdb2";